const JOURNAL_REMINDERS = new Set([
  'journal_daily_reminder',
  'weekly_reflection',
  'journal_draft_rescue',
  'journal_reengagement',
]);

// Coarse local timing only. No text, mood, title, URL, time zone or record id.
export function journalTimingContext(date = new Date()) {
  return { local_hour: date.getHours(), local_weekday: date.getDay() };
}

export function journalPushTiming(type, date = new Date()) {
  return JOURNAL_REMINDERS.has(type) ? journalTimingContext(date) : {};
}
